import axiosClient from '@/config/api/axios'
import { CONVERSATIONS } from '@/config/api/endpoints'
import { isApiConfigured } from '@/config/api/env'
import { conversationToMessages, conversationToThread } from './conversationMappers'
import { threadRequestConfig } from './threadRequestConfig'
import { threadListParams } from './threadListParams'

export function isThreadsApiAvailable() {
  return isApiConfigured()
}

export async function fetchThreads(options = {}) {
  if (!isThreadsApiAvailable()) return []
  const { data } = await axiosClient.get(
    CONVERSATIONS,
    threadRequestConfig({ ...options, params: threadListParams(options) }),
  )
  return (Array.isArray(data) ? data : []).map((row) =>
    conversationToThread({ ...row, workspace_id: row.workspace_id ?? options.workspaceId }),
  )
}

export async function fetchThreadMessages(id, options = {}) {
  if (!isThreadsApiAvailable()) return []
  const { data } = await axiosClient.get(`${CONVERSATIONS}/${id}`, threadRequestConfig(options))
  return conversationToMessages(data)
}

export {
  createThread,
  updateThreadTitle,
  updateThreadModel,
  deleteThread,
} from './threadMutations'
